export default __webpack_public_path__ + "static/pca-30678497df50f7248f5b8123bd50099d.png";